import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { PeriodicExecution } from '../model/periodicExecution';
import { DeviceService } from '../service/device.service';
import { TimeSlotDialogComponent } from '../time-slot-dialog/time-slot-dialog.component';
import { Log } from '../util/log';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { StringHelper } from '../util/stringHelper';
import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Overlay } from '@angular/cdk/overlay';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { ProgrammedExecution } from '../model/programmedExecution';
import { Automation } from '../model/automation';
import { DateHelper } from '../util/dateHelper';

@Component({
  selector: 'app-add-automation',
  templateUrl: './add-automation.component.html',
  styleUrls: ['./add-automation.component.css']
})
export class AddAutomationComponent implements OnInit {

  @ViewChild('loader', { static: true }) loader;

  description: string = "";

  noDeviceSelectedError: boolean = false;
  invalidDatesError: boolean = false;
  dateOver2100Error: boolean = false;

  automation: Automation;

  devices: DevicePilomat[] = [];
  selectedDevices: string[] = [];

  deviceSelected: boolean = false;

  allDays: boolean[] = [];

  @ViewChild('deviceslisttable', { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = [
    'serial',
    'name',
    'checkbox'
  ];

  fromFormControl: FormControl;
  toFormControl: FormControl;
  minDate: Date = new Date();

  constructor(
    private deviceService: DeviceService,
    private overlay: Overlay,
    public dialogRef: MatDialogRef<AddAutomationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
  ) {
    this.devices = data.devices;

    for (let i = 0; i < this.devices.length; i++) {
      this.devices[i].selected = false;
    }

    this.automation = new Automation();
    this.automation.timeMask = "111111111111111111111111111111111111111111111111";
    this.automation.dayMask = 127;
    this.automation.timeSlots = [];
    this.automation.timeZone = "Europe/Rome";

    for (let i = 0; i < 7; i++) {
      this.allDays.push(this.automation.isDayAllowed(i + 1));
    }

    let todayDate = new Date();
    todayDate.setHours(0);
    todayDate.setMinutes(0);
    todayDate.setSeconds(0);
    todayDate.setMilliseconds(0);

    this.automation.startDate = DateHelper.formatDateRFC3339(todayDate);

    let oneMonthDate = new Date();
    oneMonthDate.setMonth(oneMonthDate.getMonth() + 1);

    oneMonthDate.setHours(24);
    oneMonthDate.setMinutes(0);
    oneMonthDate.setSeconds(0);
    oneMonthDate.setMilliseconds(0);

    this.automation.expirationDate =
      DateHelper.formatDateRFC3339(oneMonthDate);



    this.fromFormControl = new FormControl(this.automation.startDate);
    this.toFormControl = new FormControl(this.automation.expirationDate);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.table.dataSource = new MatTableDataSource(this.devices);
    this.table.dataSource.sort = this.sort;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addSelectedDevice(device) {
    if (device.selected) {
      this.deviceSelected = false;
      for (let i = 0; i < this.selectedDevices.length; i++) {
        if (this.selectedDevices[i] == device.serial) {
          this.selectedDevices.splice(i, 1);
        }
      }
      device.selected = false;
    } else {
      this.selectedDevices.push(device.serial);
      this.deviceSelected = true;
      device.selected = true;
    }
  }

  onDayChanged(day: number, event: any) {
    let value: boolean = event.target.checked;
    this.allDays[day - 1] = value;
  }

  addTimeSlot() {
    let minPrecision = 10;
    const dialogRef = this.dialog.open(TimeSlotDialogComponent, {
      width: "450px",
      data: { minPrecision }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.automation.timeSlots.push(result);
      }
    });
  }

  deleteTimeSlot(index: number) {
    this.automation.timeSlots.splice(index, 1);
  }

  addAutomation() {
    this.noDeviceSelectedError = false;
    if (this.selectedDevices.length == 0) {
      this.noDeviceSelectedError = true;
    } else {
      this.loader.showLoading();

      let from: Date;
      if (this.fromFormControl.value) {
        from = new Date(this.fromFormControl.value);
      } else {
        from = new Date(this.automation.startDate);
      }
      // from.setHours(0);
      // from.setMinutes(0);
      // from.setSeconds(0);
      // from.setMilliseconds(0);

      let to: Date;
      if (this.toFormControl.value != null) {
        to = new Date(this.toFormControl.value);
      } else {
        to = new Date(this.automation.expirationDate);
      }

      // to.setHours(23);
      // to.setMinutes(59);
      // to.setSeconds(59);
      // to.setMilliseconds(0);

      if (from >= to || to <= new Date()) {
        this.invalidDatesError = true;
        this.loader.hideLoading();
        return;
      }

      if (to.getFullYear() > 2100) {
        this.dateOver2100Error = true;
        this.loader.hideLoading();
        return;
      }

      this.automation.timeZone = moment.tz.guess();
      this.automation.startDate = DateHelper.formatDateRFC3339(from);
      this.automation.expirationDate = DateHelper.formatDateRFC3339(to);
      let timeMask: string = "00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

      if (this.automation.timeSlots.length > 0) {
        for (let i = 0; i < this.automation.timeSlots.length; i++) {
          let timeSlotMask = TimeSlotHelper.timeSlot10MinToBinaryString(
            this.automation.timeSlots[i]
          );

          for (let j = 0; j < 144; j++) {
            if (timeSlotMask.charAt(j) == "1") {
              timeMask = StringHelper.replaceAt(timeMask, j, "1");
            }
          }
        }
      } else {
        timeMask = "11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111";
      }


      let dayMask: number = 0;
      for (let i = 0; i < this.allDays.length; i++) {
        if (this.allDays[i]) {
          dayMask |= 1 << i;
        }
      }

      this.automation.timeMask = timeMask;
      this.automation.dayMask = dayMask;


      // TODO capire come usare la description della automation
      this.automation.name = this.description;

      Log.debug("Automation to create: ");
      Log.debug(this.automation);


      this.createAutomation(0);
    }
  }

  createAutomation(index: number) {
    if (index < this.selectedDevices.length) {
      this.automation.serial = this.selectedDevices[index];
      this.deviceService.createAutomation(this.selectedDevices[index], this.automation).subscribe((response) => {

        setTimeout(() => {
          this.createAutomation(index + 1);
        }, 100);

      }, (err) => {
        Log.debug(err);
        this.dialogRef.close("Error");
      });
    } else {
      setTimeout(() => {
        this.dialogRef.close("Success");
      }, 250);
    }
  }
}
